import axios from "axios";
import { supabase, API_BASE } from "./supabase";

export const api = axios.create({ baseURL: API_BASE });

// --- DEV ONLY: Role Switcher UAT. Hapus blok ini + interceptor-nya
//     bersama backend/dev_impersonation.py sebelum Production.
//
//     sessionStorage, BUKAN localStorage: penyamaran harus mati bersama tab.
//     Seluruh gagasan fitur ini adalah "yang tertinggal tidak bisa lupa" —
//     menyimpannya di localStorage mengembalikan persis masalah yang mau
//     dihindari, yaitu keadaan yang bertahan lebih lama dari niat orangnya.
export const IMPERSONATION_KEY = "etams.dev.impersonation";

export function getImpersonationToken() {
  try {
    return sessionStorage.getItem(IMPERSONATION_KEY);
  } catch {
    return null;
  }
}

export function setImpersonationToken(token) {
  try {
    if (token) sessionStorage.setItem(IMPERSONATION_KEY, token);
    else sessionStorage.removeItem(IMPERSONATION_KEY);
  } catch {
    /* mode privat / storage diblokir — abaikan, penyamaran cuma tidak aktif */
  }
}
// --- akhir blok DEV ONLY ---

api.interceptors.request.use(async (config) => {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // DEV ONLY — header penyamaran. Backend mengabaikannya total kalau
  // ENABLE_DEV_TOOLS mati atau tanda tangannya tidak sah.
  const imp = getImpersonationToken();
  if (imp && !config.headers["X-ETAMS-Impersonate"]) {
    config.headers["X-ETAMS-Impersonate"] = imp;
  }
  return config;
});
